<template>
  <Catalog
    title="Статус отклика"
    name-label="Название статуса"
    submit-error="Укажите название статуса отклика."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :min-name-length="2"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "RecruitResponseStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getRecruitResponseStatusById(id);
    },
    async putData(data) {
      return await this.putRecruitResponseStatus(data);
    },
    async postData(data) {
      return await this.postRecruitResponseStatus(data);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitResponseStatuses/RecruitResponseStatus.vue